module.exports = {
  "conn-con8": {
    "identifierType": "PORTAL_ID",
    "maxAge": 0,
    "parameters": {
      "group": [
        "control",
        "variantA"
      ]
    }
  },
  "copy-con9": {
    "identifierType": "PORTAL_ID",
    "maxAge": 0,
    "parameters": {
      "group": [
        "control",
        "variantA"
      ]
    }
  },
  "acad-0029": {
    "identifierType": "PORTAL_ID",
    "maxAge": 0,
    "parameters": {
      "group": [
        "control",
        "variationA",
        "variationB",
        "variationC"
      ]
    }
  },
  "acad-0004": {
    "identifierType": "PORTAL_ID",
    "maxAge": 0,
    "parameters": {
      "group": [
        "control",
        "variation1",
        "variation2"
      ]
    }
  },
  "acad-0009": {
    "identifierType": "PORTAL_ID",
    "maxAge": 0,
    "parameters": {
      "group": [
        "control",
        "variationA",
        "variationB"
      ]
    }
  },
  "acad-0011": {
    "identifierType": "PORTAL_ID",
    "maxAge": 0,
    "parameters": {
      "group": [
        "control",
        "variation"
      ]
    }
  }
};